import styles from './Drawer.module.scss';
import { Drawer as DrawerComponent } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { changeDrawerVisibility } from '../../../redux/actions/sider-menu';
import Menu from '../Sider/Menu/Menu';
import Logo from '../Sider/Logo/Logo';

const Drawer = () => {
    const dispatch = useDispatch();

    const visible = useSelector(state => state.siderMenu.isDrawerVisible);

    const onClose = () => {
        dispatch(changeDrawerVisibility(false));
    };

    return (
        <DrawerComponent
            className={styles.drawer}
            placement={'left'}
            closable={false}
            visible={visible}
            onClose={onClose}
        >
            <div className={styles.drawerHeader}>
                <Logo />
            </div>
            <Menu />
        </DrawerComponent>
    );
};

export default Drawer;
